import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSinglePublisherAction = createAsyncThunk(
    'get-single-publisher-app-details',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/single-publisher-details/${data}`) 
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSinglePublisherSlice = createSlice({
    name: 'get-single-publisher-app-details',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSinglePublisherAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSinglePublisherAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSinglePublisherAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSinglePublisherReducer = getSinglePublisherSlice.reducer